import { render, staticRenderFns } from "./rankingItem.vue?vue&type=template&id=2c73b38e&scoped=true&"
import script from "./rankingItem.vue?vue&type=script&lang=js&"
export * from "./rankingItem.vue?vue&type=script&lang=js&"
import style0 from "./rankingItem.vue?vue&type=style&index=0&id=2c73b38e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c73b38e",
  null
  
)

export default component.exports